/** @format */
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UrlService } from '@uirouter/core';
import { StudyRightExtensionWorkflowPaymentService } from '../study-right-extension-workflow-payment.service';

@Component({
    selector: 'app-study-right-extension-workflow-paytrail-confirmation',
    templateUrl: './study-right-extension-workflow-paytrail-confirmation.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StudyRightExtensionWorkflowPaytrailConfirmationComponent implements OnInit {
    private readonly studyRightExtensionWorkflowPaymentService = inject(StudyRightExtensionWorkflowPaymentService);
    private readonly urlService = inject(UrlService);

    ngOnInit(): void {
        // Paytrail redirects the user back to Sisu with all the payment information included in the query parameters.
        const queryParams = this.urlService.search();
        this.studyRightExtensionWorkflowPaymentService.completePaytrailPayment(queryParams);
    }
}
